import { useSelector, useDispatch } from 'react-redux'
import { API, graphqlOperation } from 'aws-amplify'
import { v4 as uuidv4 } from 'uuid'
import { useEffect, useCallback } from 'react'
import { setCreateNewOccupancy } from '../redux/auth/actions'
import { SET_USER_OCCUPANCIES } from '../redux/actionTypes'
import { showBuildingPicker } from '../redux/app/actions'

const createMutation = `mutation CreateAssociation($input: createOccupantInput) {
    createAssociation(input: $input) {
        pk
        sk
        d1
        d2
        firstName
        lastName
        email
        version
        building
        tenant
        client
        property
    }
}`

const listOccupancy = `query($sk: String, $pk: ID) {
    listOccupancy(sk: $sk, pk: $pk) {
        items {
            pk
            sk
            d1
            d2
            roles
            firstName
            lastName
            email
            workPhone {
                number
                extension
            }
            phone {
                number
                extension
            }
            tenant
            building
            property
        }
    }
}`

export const useCreateOccupancy = () => {
    const dispatch = useDispatch()

    const createNewOccupancy = useSelector((state) => state.auth.createNewOccupancy)
    const user = useSelector((state) => state.app.user)
    const data = useSelector((state) => state.auth.data)

    const getDefaultUserAttributes = useCallback(() => {
        return {
            pk: user.attributes.sub,
            firstName: user.attributes.given_name,
            lastName: user.attributes.family_name,
            email: user.attributes.email,
        }
    }, [user])

    const fetchAndCreateOccupancy = useCallback(async () => {
        const { pk, firstName, lastName, email } = getDefaultUserAttributes()

        const inputData = {
            pk,
            sk: `OCCUPANCY#${data.tenant.pk}`,
            d1: `${data.tenant.d1}#${data.tenant.pk}#${''}#${''}`,
            d2: uuidv4(),
            email,
            firstName,
            lastName,
            registrationDate: Date.now(),
            roles: ['OCCUPANT'],
            version: 1,
        }

        try {
            const resOccupancies = await API.graphql(graphqlOperation(listOccupancy, { pk: pk, sk: 'OCCUPANCY' }))
            let occupancies = resOccupancies.data.listOccupancy.items
            const res = await API.graphql(graphqlOperation(createMutation, { input: inputData }))

            if (res.data.createAssociation) {

                dispatch({
                    type: SET_USER_OCCUPANCIES,
                    data: [...occupancies, res.data.createAssociation],
                })

                showBuildingPicker(true)
                setCreateNewOccupancy(false)
            }
        } catch (e) {
            // console.error('Error creating occupancy: ', e)
            setCreateNewOccupancy(false)
        }
    }, [getDefaultUserAttributes, data, dispatch, user])

    useEffect(() => {
        if (createNewOccupancy) {
            fetchAndCreateOccupancy()
        }
    }, [createNewOccupancy, fetchAndCreateOccupancy])
}

